import { Plugins, Match } from '@leverege/plugin';
import MoltenUtil from "../../../MoltenUtil.js";
function createMatch(objectType, path, relationship, client) {
  return {
    client: client || 'MapDataViewer',
    objectType,
    path,
    isItem: relationship.isItem === true || relationship.isOneToOne === true,
    relationship
  };
}

/**
 * Cache and return the layer renderers to use
 */
const getRendererPlugins = (caches, objectType, path, relationship, pluginType = 'MapBoxRenderer', client = 'MapDataViewer') => {
  // TODO: The relationship obj is recreated more than it needs to be

  return caches.calc('plugins', (objectType, path, relationship) => {
    const matches = createMatch(objectType, path, relationship, client);
    const v = Plugins.createView(pluginType, {
      name: relationship.urlPath,
      filter: layer => {
        return layer.layerName != null && Match.isMatch(matches, layer.matches);
      }
    });
    return v.get();
  }, objectType, path, relationship, Plugins.getVersion(pluginType)); // , Date.now() )
};
const getAutoCenterPlugins = (mapViewer, objectType, path, relationship, pluginType = 'MapViewerAutoCenter', client = 'MapDataViewer') => {
  return mapViewer.caches.calc('autoCenterPlugins', (objectType, path, relationship) => {
    const matches = createMatch(objectType, path, relationship, client);
    const v = Plugins.createView(pluginType, {
      name: relationship.urlPath,
      sort: MoltenUtil.numSortComparator,
      filter: plg => {
        return Match.isMatch(matches, plg.matches);
      }
    });
    return v.get();
  }, objectType, path, relationship, Plugins.getVersion(pluginType));
};
const getSelectionCenterPlugins = (mapViewer, objectType, path, relationship, pluginType = 'MapViewerSelectionCenter', client = 'MapDataViewer') => {
  return mapViewer.caches.calc('selectionCenterPlugins', (objectType, path, relationship) => {
    const matches = createMatch(objectType, path, relationship, client);
    const v = Plugins.createView(pluginType, {
      name: relationship.urlPath,
      sort: MoltenUtil.numSortComparator,
      filter: plg => {
        return Match.isMatch(matches, plg.matches);
      }
    });
    return v.get();
  }, objectType, path, relationship, Plugins.getVersion(pluginType));
};
export default {
  getRendererPlugins,
  getAutoCenterPlugins,
  getSelectionCenterPlugins
};